import { render, staticRenderFns } from "./BacMenu.vue?vue&type=template&id=58f3bde9&"
import script from "./BacMenu.vue?vue&type=script&lang=ts&"
export * from "./BacMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports